export enum EEntity {
  BENEFITS = 1,
  REQUIREMENTS = 2,
  RANKS = 3,
  CLASSIFICATION = 4,
  CONFIGURATION = 5,
  USERS = 6,
}
